// src/pages/Templates/TemplateFormPage.tsx

import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import TemplateForm from "../../components/template/TemplateForm";
import templateService, { Template, CreateTemplateData, UpdateTemplateData } from "../../services/template.service";
import Loader from "../../widgets/Loader";

function TemplateFormPage() {
  const { templateId } = useParams<{ templateId: string }>();
  const navigate = useNavigate();
  
  // Use the correct type here for better type safety
  const [template, setTemplate] = useState<Template | null>(null); 
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFetching, setIsFetching] = useState(!!templateId);

  const isEditMode = !!templateId;

  useEffect(() => {
    if (templateId) {
      const fetchTemplateData = async () => {
        setIsFetching(true);
        try {
          const response = await templateService.getTemplateById(templateId); 
          
          // --- FIX: Uncomment this line ---
          // This will update the state and trigger a re-render
          setTemplate(response.data); 
          
        } catch (error) {
          toast.error("Failed to fetch template data.");
          navigate("/templates");
        } finally {
          setIsFetching(false);
        }
      };
      fetchTemplateData();
    }
  }, [templateId, navigate]);

  const handleFormSubmit = async (data: CreateTemplateData | UpdateTemplateData) => {
    // ... (Your submit logic remains the same)
    setIsSubmitting(true);
    try {
      if (isEditMode && templateId) { // Add templateId check for type safety
        await templateService.updateTemplate(templateId, data as UpdateTemplateData);
        toast.success(`Template updated successfully!`);
      } else {
        await templateService.createTemplate(data as CreateTemplateData);
        toast.success(`Template created successfully!`);
      }
      navigate("/templates");
    } catch (error: any) {
      console.error("Error saving template:", error);
      if (error?.response?.data?.error?.error_description) {
        toast.error(error?.response?.data?.error?.error_description);
      } else if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(isEditMode ? "Failed to update template" : "Failed to create template");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isFetching) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div className="bg-gray">
      <TemplateForm
        template={template}
        onSubmit={handleFormSubmit}
        isLoading={isSubmitting}
      />
    </div>
  );
}

export default TemplateFormPage;